import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const editFullName = ({first_name, last_name}) => {
  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.PUT,
    path: `/api/v1/users`,
    body: {
      user: {
        first_name,
        last_name,
      },
    },
  });
};

export default editFullName;
